import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faTwitter, faTiktok } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  const { language } = useContext(LanguageContext);

  const content = {
    fr: {
      contact: "Contact",
      address: "Adresse: 3 Rue du Port, 1204 Genève - CH",
      email: "Email: Doyoufarahman@gmail.com",
      phone: "Téléphone: +41 79 924 74 24",
      social: "Réseaux sociaux",
      usefulLinks: "Liens Utiles",
      cookiePolicy: "Politique de Cookies",
      privacyPolicy: "Politique de Confidentialité",
      help: "Aide",
      about: "À propos",
      aboutText: "Doyouf Arahman Travels est une agence dédiée à l'organisation de voyages spirituels Omra et Hajj.",
      rights: `© ${new Date().getFullYear()} Doyouf Arahman Travels. Tous droits réservés.`,
    },
    ar: {
      contact: "اتصل بنا",
      address: "العنوان: 3 Rue du Port, 1204 جنيف - سويسرا",
      email: "البريد الإلكتروني: Doyoufarahman@gmail.com",
      phone: "الهاتف: +41 79 924 74 24",
      social: "وسائل التواصل الاجتماعي",
      usefulLinks: "روابط مفيدة",
      cookiePolicy: "سياسة الكوكيز",
      privacyPolicy: "سياسة الخصوصية",
      help: "مساعدة",
      about: "حولنا",
      aboutText: "Doyouf Arahman Travels هي وكالة متخصصة في تنظيم رحلات العمرة والحج الروحية.",
      rights: `© ${new Date().getFullYear()} Doyouf Arahman Travels. جميع الحقوق محفوظة.`,
    },
  };

  return (
    <footer className="bg-white py-8" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
         
          <div>
            <h4 className="font-bold text-gray-800 mb-4">{content[language].contact}</h4>
            <p className="text-gray-700">{content[language].address}</p>
            <p className="text-gray-700">{content[language].email}</p>
            <p className="text-gray-700">{content[language].phone}</p>
          </div>

       
          <div>
            <h4 className="font-bold text-gray-800 mb-4">{content[language].social}</h4>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/doyoufarahman" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 text-xl">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
             
              <a href="https://www.instagram.com/doyoufarahman1" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-pink-500 text-xl">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.tiktok.com/@doyouf.arahman" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-black text-xl">
                <FontAwesomeIcon icon={faTiktok} />
              </a>
            </div>
          </div>

          
          <div>
            <h4 className="font-bold text-gray-800 mb-4">{content[language].usefulLinks}</h4>
            <ul className="list-none space-y-2">
              <li>
                <a href="/politique-cookies" className="text-gray-700 hover:text-gray-900">
                  {content[language].cookiePolicy}
                </a>
              </li>
              <li>
                <a href="/politique-confidentialite" className="text-gray-700 hover:text-gray-900">
                  {content[language].privacyPolicy}
                </a>
              </li>
              <li>
                <a href="/aide" className="text-gray-700 hover:text-gray-900">
                  {content[language].help}
                </a>
              </li>
            </ul>
          </div>

          
          <div>
            <h4 className="font-bold text-gray-800 mb-4">{content[language].about}</h4>
            <p className="text-gray-700">{content[language].aboutText}</p>
          </div>
        </div>

       
        <div className="mt-8 text-center text-gray-600 border-t pt-8">
          <p>{content[language].rights}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
